/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

declare const Piwik: any;

export const Action = {
  Checkbox: 'checkbox',
  ClickThrough: 'clickthrough',
  Deselect: 'deselect',
  Input: 'input',
  MissingValue: 'missing-value',
  Modal: 'modal',
  Next: 'next',
  Select: 'select',
  Submit: 'submit',
  Render: 'render',
  Unrender: 'unrender',
  RadioSelect: 'radioSelect',
  Transition: 'transition'
};

export type EventTracker = (category: string, action: string) => void;

/**
 * Normalize events sent to Piwik. User ID is being tracked with setUserId().
 * @param {string} category - e.g. 'account'
 * @param {string} action - e.g. 'address.update' NOTE: arbitrary dot notation is permitted
 * @param {number} value - e.g. 200 - The event value. Must be a float or integer value (numeric), not a string.
 */
export const trackEvent = (
  category: string,
  action: string,
  value?: number
) => {
  if (typeof Piwik === 'undefined') {
    return;
  }

  const eventName = `qh.app.rtr.selfReferral.${category}.${action}`;
  Piwik.getAsyncTracker().trackEvent(category, action, eventName, value);
};
